import React from "react";
import TextInline from "pages/ClaimSupport/TextInline";
import { WidthLimiter } from "pages/PlanSetup/styles";
import styled from "styled-components";
import { useNavigate } from "react-router";
import useUser from "hooks/useUser";

function UserProfile() {
  const { getLoggedInUserDetail } = useUser();
  const { name, email } = getLoggedInUserDetail();

  const navigate = useNavigate();
  const redirectToChangePassword = () => {
    navigate("/v1/profile/change-password");
  };
  return (
    <>
      <div>
        <WidthLimiter>
          <div
            style={{ display: "flex", flexDirection: "column", gap: "2rem" }}
          >
            <TextInline name={name} label={"Name"} height={"52px"} />
            <TextInline name={email} label={"Email"} height={"52px"} />
            <ChangePasswordButton onClick={() => redirectToChangePassword()}>
              Change Password
            </ChangePasswordButton>
          </div>
        </WidthLimiter>
      </div>
    </>
  );
}

export default UserProfile;

const ChangePasswordButton = styled.div`
  border: 1px solid rgb(35, 26, 61);
  padding: 14px 24px;
  color: rgb(35, 26, 61);
  background-color: transparent;
  border-radius: 7px;
  cursor: pointer;
  font-size: 16px;
  margin-top: 2rem;
  font-family: "Inter";
  font-weight: 500;
  width: fit-content;
`;
